<template>
  <div>
    <GmapMarker
      v-if="myplace"
      :position="myplace"
      :clickable="false"
      :draggable="false"
      :icon="icon()" >
    </GmapMarker>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'

export default {
  created () {
    this.myplace = this.$store.getters['geolocation/getLocation']
  },
  data () {
    return {
      myplace: {}
    }
  },
  methods: {
    icon: function() {
      if (this.google) {
        let size = new this.google.maps.Size(36, 36)
        return {
          url: this.iconPath(),
          scaledSize: size
        }
      }
    },
    iconPath() {
      return require('@/assets/images/my_location-24px.svg')
    }
  },
  computed: {
    ...mapGetters({
      center: 'geolocation/getLocation'
    }),
    google: gmapApi
  },
  watch: {
    center: {
      handler: function () {
        this.myplace = this.$store.getters['geolocation/getLocation']
      },
      deep: true
    }
  }
}
</script>
